import { render, staticRenderFns } from "./FeaturedProjects.vue?vue&type=template&id=a1f82a44&scoped=true&"
import script from "./FeaturedProjects.vue?vue&type=script&lang=js&"
export * from "./FeaturedProjects.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedProjects.vue?vue&type=style&index=0&id=a1f82a44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f82a44",
  null
  
)

export default component.exports